import { Navigate, useParams } from "react-router-dom";

/**
 * The generic `/events` routes exist so the URL space is future-proof —
 * once a second vertical (XV años, corporate, ...) ships, `/events` will
 * become a real cross-vertical list and `/events/:eventId` will dispatch
 * to the right vertical's detail page based on the event's EventType.
 *
 * Today there is only one vertical, so both redirect straight to their
 * wedding-labeled equivalent. `eventId` and `weddingId` are the same
 * string (see src/lib/adapters/wedding-event-adapter.ts), so the redirect
 * is a direct passthrough, not a lookup.
 */
export function EventDetailRedirect() {
  const { eventId } = useParams<{ eventId: string }>();
  return <Navigate to={`/weddings/${eventId}`} replace />;
}
